import React, { useState, useEffect } from "react";
import { fetchPoolModels } from "../../../utils/Pool/fetchPoolModels";
import "react-datepicker/dist/react-datepicker.css";
import RenderModel from "../../RenderModel";
import ReactPDF, { PDFDownloadLink } from '@react-pdf/renderer';
import PDFBooking from './PDFBooking';

const initialTimeline = [
    { date: "23.03.2025", address: "Berlin, Germany", models: [] },
    { date: "22.03.2025", address: "Paris, France", models: [] },
    { date: "01.04.2025", address: "Madrid, Spain", models: [] }
];

const BookingView = ({ selectedBooking = null, setSelectedBooking = () => { }, bookings, setIsEditMode = () => { } }) => {
    const [models, setModels] = useState([]);
    const [timeline, setTimeline] = useState(initialTimeline);

    useEffect(() => {
        if (selectedBooking) {
            fetchPoolModels(
                selectedBooking.pool_id,
                (fetchedModels) => {
                    setModels(fetchedModels);

                    // Insert the first model into the first timeline entry
                    if (fetchedModels.length > 0) {
                        setTimeline((prevTimeline) => {
                            const updated = [...prevTimeline];
                            updated[0] = {
                                ...updated[0],
                                models: [fetchedModels[0]]
                            };
                            updated[1] = {
                                ...updated[1],
                                models: [fetchedModels[0], fetchedModels[1]]
                            };
                            return updated;
                        });
                    }
                },
                () => { },
                () => { },
                1,
                10
            );
        }
    }, [selectedBooking]);

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "20px", padding: "20px" }}>
            <div className="flex-row">
                <button className="big-button" onClick={() => { setSelectedBooking(null) }}>Back To All Booking</button>
                <button className="big-button" onClick={() => { setIsEditMode(true) }}>Edit Booking</button>
                <PDFDownloadLink document={<PDFBooking models={models} booking={selectedBooking} timeline={timeline} />} fileName="BookingPDF">
                    {({ loading }) => loading ? (<button className="big-button" disabled={true}>Loading PDF...</button>) : (<button className="big-button">Download PDF</button>)}
                </PDFDownloadLink>
            </div>

            <h3 className="modal-title">Models in {selectedBooking.pool_id}</h3>
            {models.length > 0 && (
                <div
                    className="model-list"
                >
                    {models.map((model, index) => (
                        <div
                            style={{
                                padding: "10px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",

                            }}
                        >
                            <RenderModel model={model} />
                        </div>
                    ))}
                </div>
            )}

            <hr></hr>

            <div>
                <h1 className="title">Timeline</h1>
                {timeline.map((entry, index) => (
                    <div
                        style={{
                            padding: "15px",
                            borderRadius: "5px",
                            display: "flex",
                            gap: "10px",
                            minHeight: "100px",
                        }}
                    >
                        <div style={{ minWidth: "150px", fontWeight: "bold", textAlign: "center", alignSelf: "center" }}>
                            {entry.date} - {entry.address}
                        </div>

                        {entry.models.length === 0 && (
                            <div style={{ padding: "20px", background: "lightgrey", textAlign: "center", alignSelf: "center" }}>
                                No Model for this Date
                            </div>
                        )}

                        <div className="model-timeline">

                            {entry.models.map((model) => (
                                <div
                                    style={{
                                        padding: "5px",
                                        background: "#fff",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}
                                    key={model.id + "timeline"}
                                >
                                    <RenderModel model={model} modelStyle="model-item-timeline" />
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default BookingView;
